import React, { Component } from "react";

import { Container, Row, Col } from "react-bootstrap";
import { Styles } from "./styles/events.js";
import { BreadcrumbBox } from "../../components/common/Breadcrumb.js";
import HeaderTwo from "../../components/HeaderTwo.js";
import FooterTwo from "../../components/FooterTwo.js";
import PopularSmart from "../../components/facilities/PopularSmart.js";

class SmartClass extends Component {
  render() {
    return (
      <Styles>
        {/* Main Wrapper */}
        <div className="main-wrapper event-details-page">
          {/* Header 2 */}
          <HeaderTwo />

          {/* Breadcrumb */}
          <BreadcrumbBox title="Smart Class" />

          {/* Smart Class Details Area */}
          <section className="event-details-area">
            <Container>
              <Row>
                <Col lg="9" md="8" sm="12">
                  <div className="event-details-content">
                    <div className="heading">
                      <h4>Smart Class Facilities for Enhanced Learning</h4>
                    </div>
                    <div className="event-icon">
                      <ul className="list-unstyled list-inline">
                        <li className="list-inline-item">
                          <i className="las la-chalkboard-teacher"></i> Interactive Learning
                        </li>
                        <li className="list-inline-item">
                          <i className="las la-desktop"></i> Digital Resources
                        </li>
                        <li className="list-inline-item">
                          <i className="las la-network-wired"></i> High-Tech Infrastructure
                        </li>
                      </ul>
                    </div>
                    <div className="event-details-banner">
                      <img
                        src={process.env.PUBLIC_URL + `/assets/images/smart2.jpg`}
                        alt="Smart Class"
                        className="img-fluid"
                      />
                    </div>
                    <div className="event-details-overview">
                      <h5>Smart Class Overview</h5>
                      <p>
                      Our institution proudly offers 13 state-of-the-art smart classrooms, each equipped with advanced technology to create an engaging and immersive learning environment. These classrooms seamlessly integrate digital tools, interactive whiteboards, high-speed internet, and multimedia resources to enhance the educational experience. By incorporating innovative teaching methodologies, such as real-time simulations, virtual labs, and AI-driven learning platforms, students can grasp complex concepts with greater clarity and retention. The interactive nature of these smart classrooms fosters collaboration, critical thinking, and creativity, ensuring a more dynamic and effective approach to education. Additionally, educators can utilize digital assessments and personalized learning modules to cater to individual student needs, further optimizing academic outcomes.
                      </p>
                      <ul className="list-unstyled">
                        <li>
                          <i className="fa fa-check"></i> High-resolution projectors provide crystal-clear images, making presentations, lectures, and meetings more engaging and visually appealing.
                        </li>
                        <li>
                          <i className="fa fa-check"></i> Online and offline digital learning materials provide students and professionals with flexible access to educational content anytime and anywhere.
                        </li>
                        <li>
                          <i className="fa fa-check"></i> When paired with high-resolution projectors, smart boards enhance collaborative learning experiences in classrooms and professional environments.
                        </li>
                        <li>
                          <i className="fa fa-check"></i>Wi-Fi connectivity enables seamless access to digital learning platforms, allowing students to engage with educational resources anytime and anywhere.
                        </li>
                      </ul>
                    </div>
                    {/* <div className="event-details-speaker">
                      <h5>Smart Class Facilities</h5>
                      <Row>
                        {Datas.map((data, i) => (
                          <Col lg="3" md="6" sm="6" key={i}>
                            <div className="event-speaker-item">
                              <img
                                src={process.env.PUBLIC_URL + `/assets/images/${data.personImage}`}
                                alt=""
                                className="img-fluid"
                              />
                            </div>
                          </Col>
                        ))}
                      </Row>
                    </div> */}
                  </div>
                </Col>
                <Col lg="3" md="4" sm="12">
                  <div className="event-details-sidebar">
                    <Row>
                      <Col md="12">
                        <div className="event-sidebar-info">
                          <ul className="list-unstyled event-info-list">
                            <li>Smart Classes: <span>13 Available</span></li>
                            <li>Technology: <span>Smartboard</span></li>
                            <li>Resources: <span>Hybrid Materials</span></li>
                            <li>Connectivity: <span>Wi-Fi Enabled</span></li>
                            <li>Collaboration: <span>Real-Time Learning</span></li>
                          </ul>
                        </div>
                      </Col>
                      <Col md="12">
                        <PopularSmart />
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>

          {/* Footer 2 */}
          <FooterTwo />
        </div>
      </Styles>
    );
  }
}

export default SmartClass;
